module.exports = __webpack_public_path__ + "img/format-image5.24670f96.png";